import { Stack } from '@mui/material';

import ForgotPasswordStepper from '../components/forgot-password-stepper';

const ForgotPasswordView = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={3}
      sx={{
        backgroundColor: 'common.white',
        p: 4,
        borderRadius: 1.5,
        width: '90%',
        maxWidth: 600,
      }}
    >
      <ForgotPasswordStepper />
    </Stack>
  );
};

export default ForgotPasswordView;
